// @ts-strict-ignore
import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AiAgentDetailsForNRO = lazy(() =>
  import("@scenes/AgentDetails").then((module) => ({
    default: module.AgentDetails,
  }))
);

export const aiAgentDetailsNRO: NavigationRoutingObject = {
  Component: AiAgentDetailsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) => t("braze-ai-agent-details-nro-heading", "BrazeAI™ Agent Details"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("custom_ai_agents")) {
      return false;
    }

    const userHasViewCustomAgentsPermission = hasPermission("appGroupOrAnyTeamInAppGroup", {
      permission: "viewCustomAgents",
    });

    return isImpersonating || userHasViewCustomAgentsPermission;
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/agent_console/agents/:appGroupId",
};
